import { CdkMenu } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, ContentChildren, ElementRef, Input, QueryList } from '@angular/core';
import { ComponentBaseComponent } from '../../component-base/component-base.component';
import { filter } from 'rxjs';
import { ContextMenuItemComponent } from '../context-menu-item/context-menu-item.component';

@Component({
    selector: 'tt-context-menu',
    standalone: false,
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [CdkMenu],
    host: {
        '[style.--tt-context-menu-item-height]': 'itemHeight',
        '[class.tt-context-menu--icons]': 'hasIcons',
    },
})
export class ContextMenuComponent extends ComponentBaseComponent {
    constructor(private menu: CdkMenu, private element: ElementRef<HTMLElement>) { super(); }

    @ContentChildren(ContextMenuItemComponent) private items?: QueryList<ContextMenuItemComponent>;
    get hasIcons(): boolean { return this.items?.some(item => !!item.icon) ?? false; }

    @Input() ttSize: 'xs' | 'sm' | 'md' | 'lg' = 'sm';
    get itemHeight(): string {
        const height = ({ xs: 24, sm: 32, md: 40, lg: 48 })[this.ttSize] ?? 32;
        return `calc(${height} * var(--tt-context-menu-unit))`;
    }

    readonly closed = this.menu.menuStack.closed.pipe(filter(event => event.item === this.menu));

    prepareOpen(): void {
        // Projected items survive overlay detachment, so rejoin the CDK stack on reopening.
        if (this.menu.menuStack.isEmpty()) this.menu.menuStack.push(this.menu);
    }

    close(): void { this.menu.menuStack.closeAll(); }

    focusFirstItem(origin: 'mouse' | 'keyboard'): void { this.menu.focusFirstItem(origin); }
    contains(target: Node): boolean { return this.element.nativeElement.contains(target); }
}
